module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-4-Active-ClubPilates-0e08df1ba4fa9787300167176dc73ecc.png";